import ReactOnRails from "react-on-rails";
import Leaderboard from "shared/components/leaderboard/Leaderboard";

ReactOnRails.register({ Leaderboard });
